module.exports = __webpack_public_path__ + "poster2.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster2.png
// module id = 1132
// module chunks = 10